import { Page } from '@components';
import { Stack } from '@mui/material';
import SystemLogDrawer from '@SystemLog/components/SystemLogDrawer/SystemLogDrawer';
import SystemLogEvents from '@SystemLog/organisms/SystemLogEvents';
import SystemLogFilters from '@SystemLog/organisms/SystemLogFilters';

export default function SystemLogPage() {
  return (
    <Page
      title="Audit Log"
      subTitle="The Audit Log page provides a centralized view of all administrative events and changes within your account, allowing you to trace down specific changes, and maintain security and compliance."
    >
      <Stack spacing={2}>
        <SystemLogFilters />
        <SystemLogEvents />
        <SystemLogDrawer />
      </Stack>
    </Page>
  );
}
